import Vue from 'vue'
import App from './App.vue'
// 引入状态管理
import store from '@/store/index.js'

// 引入移动端自适应
import 'lib-flexible/flexible.js'

// 引入vant组件
import '@/utils/vant-plugins.js'

// 引入路由
import router from '@/router/index.js'

Vue.config.productionTip = false

new Vue({
    render: h => h(App),
    store,
    router
}).$mount('#app')
